/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  settings: '设置',
  setting: 'Setting',
  defaultLocale: '默认语言',
  mail: '邮件配置',
  driver: '协议',
  host: 'SMTP地址',
  port: '端口',
  username: '用户名',
  password: '密码',
  encryption: '加密方式',
  fromAddress: '发件邮箱',
  fromName: '发件姓名',
  save: '保存',
  saveSuccess: '保存成功',
  saveFailure: '保存失败',
  fetchFailure: '无法获取设置',
  updates: '更新',
  update: 'Update',
  newUpdatesAvailable: '有新版本',
  beforeUpdatingMakeSure: '更新前，请确保Plainpad的安装目录可写。如果在更新后报错，则需要在终端手动运行“php artisan refresh”命令',
}
